import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/data/issues");

export const Route = createFileRoute("/data/issues/")({
  head: () => ({
    meta: [
      { title: "Data feed issues — LevelLoad" },
      {
        name: "description",
        content: "Open problems reported by the data feeds LevelLoad plans from.",
      },
      { property: "og:title", content: "Data feed issues — LevelLoad" },
      {
        property: "og:description",
        content: "Open problems reported by the data feeds LevelLoad plans from.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
